export default __webpack_public_path__ + "static/media/BiosensorFigure7.2cfd210d.svg";